import Image from "next/image";
import styled from "styled-components";
import { colors, spacing, textStyles, toCSS } from "design-system/foundation";
import { breakpoints } from "styles";

export const ErrorWrapper = styled.div<{ $isEmbedded?: boolean }>`
  &,
  & *,
  & *::before,
  & *::after {
    box-sizing: border-box;
  }
  display: flex;
  flex-direction: column;
  gap: ${spacing["4xl"]};
  justify-content: center;
  align-items: center;
  padding: ${spacing["4xl"]} ${spacing["2xl"]};
  height: ${({ $isEmbedded }) => ($isEmbedded ? "auto" : "calc(100vh - 80px)")};
  min-height: ${({ $isEmbedded }) => ($isEmbedded ? "240px" : "auto")};

  @media ${breakpoints.tablet} {
    background-color: ${({ $isEmbedded }) =>
      $isEmbedded ? "transparent" : colors.bg.base.default};
  }
`;

export const ErrorContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing["2xl"]};
  align-items: center;
  @media ${breakpoints.tablet} {
    width: 296px;
  }
`;

export const ContentImage = styled(Image)`
  width: 256px;
  height: 256px;
  padding: ${spacing["2xl"]};
`;

export const ContentText = styled.p`
  margin: ${spacing.none};
  ${toCSS(textStyles.heading.h5)}
  color: ${colors.text.base.primary};
  text-align: center;
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing["2xl"]};
  width: 100%;

  @media ${breakpoints.tablet} {
    width: 296px;
  }
`;
